export interface Dash0Config {
  enabled: boolean;
  endpoint: string;
  token: string;
  environment: string;
  serviceVersion: string;
}

const PLACEHOLDER_RE = /__[A-Z0-9_]+_PLACEHOLDER__/;

function isPlaceholder(v: string): boolean {
  return PLACEHOLDER_RE.test(v);
}

export function loadConfig(env?: Record<string, string>): Dash0Config {
  const get = (key: string): string =>
    (env ? env[key] : (import.meta.env as Record<string, string>)[key]) ?? '';

  const endpoint = get('VITE_DASH0_ENDPOINT');
  const token = get('VITE_DASH0_TOKEN');
  const environment = get('VITE_DASH0_ENV');
  const serviceVersion = get('SERVICE_VERSION');

  const allPresent = Boolean(endpoint && token && environment && serviceVersion);
  const noPlaceholders = ![endpoint, token, environment, serviceVersion].some(isPlaceholder);

  return {
    enabled: allPresent && noPlaceholders,
    endpoint,
    token,
    environment,
    serviceVersion,
  };
}
